import { observable } from '../lib/utils/observable.js?vue3';

export const badgeState = observable('mr_badge_state', {
  state: '',
  updateStatus: null,
});
